// import moment from 'moment';
// import { formatMs, msFullAhora } from '../utils/time';

// const ResultadoDetailTiempo = (props) => {

//   const { guntime, resultado, prevision, competicion, controles } = props;
//   const fechaInicio = moment(props.fechaInicio);
//   let fechaFin = moment(fechaInicio);
//   fechaFin.add(2, 'days');

//   let tiempoAhora = msFullAhora(props.fechaInicio) - guntime;
//   if (resultado.guntime) {
//     tiempoAhora = msFullAhora(props.fechaInicio) - resultado.guntime;
//   }
//   // En tiempo neto: usar start si existe, sino usar guntime
//   if (competicion.tipo === 'TIEMPONETO') {
//     if (resultado.start) {
//       tiempoAhora = msFullAhora(props.fechaInicio) - resultado.start;
//     } else {
//       tiempoAhora = msFullAhora(props.fechaInicio) - guntime;
//     }
//   }

//   // Verificar si el corredor está FINALIZADO
//   let haFinalizadoCarrera = false;
//   let tiempoFinal = null;

//   // Buscar el control de META
//   const metaControl = controles && controles.length > 0
//     ? controles.find(c => c.tipo === 'META' || c.nombre === 'META')
//     : null;

//   if (metaControl) {
//     const tiempoAbsoluto = resultado['control_' + metaControl.id + '_tiempo'];

//     if (tiempoAbsoluto) {
//       haFinalizadoCarrera = true;

//       // Calcular igual que en la tabla de pasos
//       let tiempoInicioCorrector = 0;
//       if (competicion.tipo === 'TIEMPONETO' && resultado.start) {
//         tiempoInicioCorrector = resultado.start - (competicion.guntime || 0);
//       }

//       tiempoFinal = tiempoAbsoluto - tiempoInicioCorrector;
//     }
//   } else if (resultado.tiempo_neto && competicion.tipo === 'TIEMPONETO') {
//     haFinalizadoCarrera = true;
//     tiempoFinal = resultado.tiempo_neto;
//   } else if (resultado.tiempo) {
//     haFinalizadoCarrera = true;
//     tiempoFinal = resultado.tiempo;
//   }

//   // Encontrar el último control por el que pasó el corredor
//   let ultimoControlPasado = null;
//   let mostrarPrevision = false;

//   if (controles && controles.length > 0) {
//     const controlesOrdenados = [...controles].sort((a, b) => b.distancia - a.distancia);

//     for (const control of controlesOrdenados) {
//       const tiempoEnControl = resultado['control_' + control.id + '_tiempo'];
//       if (tiempoEnControl) {
//         ultimoControlPasado = control;
//         break;
//       }
//     }

//     // Verificar si la previsión debe mostrarse
//     if (prevision && prevision.control && ultimoControlPasado) {
//       if (prevision.control.distancia > ultimoControlPasado.distancia) {
//         mostrarPrevision = true;
//       }
//     } else if (prevision && prevision.control && !ultimoControlPasado) {
//       mostrarPrevision = true;
//     }
//   }
//   return (
//     <div className="w-full mb-6">
//       <div className="mx-auto max-w-5xl px-4 md:px-40 flex justify-center">
//         <div className="w-full max-w-2xl">
//           {resultado.descalificado ? (
//             <div className="bg-red-900/40 border border-red-800 rounded-lg px-6 py-8 text-center">
//               <div className="text-red-300 text-xl font-bold uppercase tracking-wide font-montserrat">
//                 DESCALIFICADO
//               </div>
//             </div>
//           ) : resultado.retirado ? (
//             <div className="space-y-4">
//               <div className="bg-slate-900/50 border border-slate-700 rounded-lg px-6 py-4 text-center">
//                 <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-2">
//                   CARRERA FINALIZADA
//                 </div>
//               </div>
//               <div className="bg-slate-800/50 border border-slate-700 rounded-lg px-6 py-8 text-center">
//                 <div className="text-slate-400 text-xl font-bold uppercase tracking-wide font-montserrat">
//                   RETIRADO
//                 </div>
//               </div>
//             </div>
//           ) : (
//             <div>
//               {haFinalizadoCarrera ? (
//                 <div className="bg-slate-900/50 border border-slate-700 rounded-lg px-6 py-8 text-center">
//                   <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-3">
//                     FINALIZÓ LA CARRERA
//                   </div>
//                   <div className="text-white text-2xl font-mono font-bold">
//                     {formatMs(tiempoFinal)}
//                   </div>
//                 </div>
//               ) : (
//                 <div>
//                   {competicion.carrera_finalizada ? (
//                     <div className="bg-slate-900/50 border border-slate-700 rounded-lg px-6 py-8 text-center">
//                       <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-3">
//                         CARRERA FINALIZADA
//                       </div>
//                       <div className="text-slate-500 text-2xl font-montserrat">
//                         Sin resultado
//                       </div>
//                     </div>
//                   ) : (
//                     <div>
//                       {!competicion.carrera_finalizada && (
//                         <div className="space-y-4">
//                           {(guntime > 0 && resultado.start) ? (
//                             <div className="bg-slate-900/50 border border-slate-700 rounded-lg px-6 py-8 text-center">
//                               <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-3">
//                                 TIEMPO EN CARRERA
//                               </div>
//                               <div className="text-white text-2xl font-mono font-bold">
//                                 {formatMs(tiempoAhora)}
//                               </div>
//                             </div>
//                           ) : (
//                             <div className="bg-slate-900/50 border border-slate-700 rounded-lg px-6 py-8 text-center">
//                               <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-3">
//                                 ESTADO
//                               </div>
//                               <div className="text-slate-500 text-2xl font-montserrat">
//                                 NO PRESENTADO
//                               </div>
//                             </div>
//                           )}

//                           {(mostrarPrevision && prevision && prevision.tiempo && tiempoAhora > 0) && (
//                             <div className="bg-slate-900/50 border border-slate-700 rounded-lg px-6 py-6">
//                               {/* Distancia recorrida */}
//                               <div className="text-center mb-4">
//                                 <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-2">
//                                   DISTANCIA RECORRIDA
//                                 </div>
//                                 <div className="text-white text-2xl font-semibold font-montserrat">
//                                   {((prevision.distancia + prevision.inicioDistancia) / 1000).toFixed(1)} km
//                                 </div>
//                               </div>

//                               {/* Previsión */}
//                               <div className="text-center mb-4">
//                                 <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-2">
//                                   PREVISIÓN EN {prevision.control.nombre}
//                                 </div>
//                                 <div className="text-red-400 text-2xl font-mono font-bold">
//                                   {formatMs(prevision.tiempoTotal)}
//                                 </div>
//                               </div>

//                               {/* Barra de progreso */}
//                               <div className="mt-4">
//                                 <div className="h-2 w-full bg-slate-800 rounded-full overflow-hidden">
//                                   <div
//                                     className="h-full bg-red-500 transition-all duration-300"
//                                     style={{ width: `${prevision.porcentaje}%` }}
//                                   />
//                                 </div>
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ResultadoDetailTiempo;
import moment from 'moment';
import { formatMs, msFullAhora } from '../utils/time';

const ResultadoDetailTiempo = (props) => {

  const { guntime, resultado, prevision, competicion, controles } = props;
  const fechaInicio = moment(props.fechaInicio);
  let fechaFin = moment(fechaInicio);
  fechaFin.add(2, 'days');

  let tiempoAhora = msFullAhora(props.fechaInicio) - guntime;
  if (resultado.guntime) {
    tiempoAhora = msFullAhora(props.fechaInicio) - resultado.guntime;
  }
  // En tiempo neto: usar start si existe, sino usar guntime
  if (competicion.tipo === 'TIEMPONETO') {
    if (resultado.start) {
      tiempoAhora = msFullAhora(props.fechaInicio) - resultado.start;
    } else {
      tiempoAhora = msFullAhora(props.fechaInicio) - guntime;
    }
  }

  // Verificar si el corredor está FINALIZADO
  let haFinalizadoCarrera = false;
  let tiempoFinal = null;

  // Buscar el control de META
  const metaControl = controles && controles.length > 0
    ? controles.find(c => c.tipo === 'META' || c.nombre === 'META')
    : null;

  if (metaControl) {
    const tiempoAbsoluto = resultado['control_' + metaControl.id + '_tiempo'];

    if (tiempoAbsoluto) {
      haFinalizadoCarrera = true;

      // Calcular igual que en la tabla de pasos
      let tiempoInicioCorrector = 0;
      if (competicion.tipo === 'TIEMPONETO' && resultado.start) {
        tiempoInicioCorrector = resultado.start - (competicion.guntime || 0);
      }

      tiempoFinal = tiempoAbsoluto - tiempoInicioCorrector;
    }
  } else if (resultado.tiempo_neto && competicion.tipo === 'TIEMPONETO') {
    haFinalizadoCarrera = true;
    tiempoFinal = resultado.tiempo_neto;
  } else if (resultado.tiempo) {
    haFinalizadoCarrera = true;
    tiempoFinal = resultado.tiempo;
  }

  // Encontrar el último control por el que pasó el corredor
  let ultimoControlPasado = null;
  let mostrarPrevision = false;

  if (controles && controles.length > 0) {
    const controlesOrdenados = [...controles].sort((a, b) => b.distancia - a.distancia);

    for (const control of controlesOrdenados) {
      const tiempoEnControl = resultado['control_' + control.id + '_tiempo'];
      if (tiempoEnControl) {
        ultimoControlPasado = control;
        break;
      }
    }

    // Verificar si la previsión debe mostrarse
    if (prevision && prevision.control && ultimoControlPasado) {
      if (prevision.control.distancia > ultimoControlPasado.distancia) {
        mostrarPrevision = true;
      }
    } else if (prevision && prevision.control && !ultimoControlPasado) {
      mostrarPrevision = true;
    }
  }
  return (
    <div className="w-full mb-6">
      <div className="mx-auto max-w-5xl px-4 md:px-40 flex justify-center">
        <div className="w-full max-w-2xl">
          {resultado.descalificado ? (
            <div className="bg-red-900/40 border border-red-800 rounded-lg px-6 py-8 text-center">
              <div className="text-red-300 text-xl font-bold uppercase tracking-wide font-montserrat">
                DESCALIFICADO
              </div>
            </div>
          ) : resultado.retirado ? (
            <div className="bg-slate-900/50 border border-slate-700 rounded-lg px-6 py-8 text-center">
              <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-3">
                CARRERA FINALIZADA
              </div>
              <div className="text-slate-400 text-xl font-bold uppercase tracking-wide font-montserrat">
                RETIRADO
              </div>
            </div>
          ) : (
            <div>
              {haFinalizadoCarrera ? (
                <div className="bg-slate-900/50 border border-slate-700 rounded-lg px-6 py-8 text-center">
                  <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-3">
                    FINALIZÓ LA CARRERA
                  </div>
                  <div className="text-white text-2xl font-mono font-bold">
                    {formatMs(tiempoFinal, competicion.mostrar_tiempo_centesimas)}
                  </div>
                  {guntime > 0 && (
                    <div className="text-white text-2xl font-mono font-bold mt-2">
                      {formatMs(((competicion.tipo === 'TIEMPONETO' && resultado.start) ? resultado.start : (resultado.guntime || guntime)) + tiempoFinal)} h
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  {competicion.carrera_finalizada ? (
                    <div className="bg-slate-900/50 border border-slate-700 rounded-lg px-6 py-8 text-center">
                      <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-3">
                        CARRERA FINALIZADA
                      </div>
                      <div className="text-slate-500 text-2xl font-montserrat">
                        NO PRESENTADO
                      </div>
                    </div>
                  ) : (
                    <div>
                      {!competicion.carrera_finalizada && (
                        <div>
                          {(guntime > 0 && resultado.start) || ultimoControlPasado ? (
                            <div className="bg-slate-900/50 border border-slate-700 rounded-lg px-6 py-6">
                              <div className="text-center mb-4">
                                <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-2">
                                  TIEMPO EN CARRERA
                                </div>
                                <div className="text-white text-2xl font-mono font-bold">
                                  {formatMs(tiempoAhora)}
                                </div>
                              </div>
                              {(mostrarPrevision && prevision && prevision.tiempo && tiempoAhora > 0 && controles.some(c => c.prevision)) && (
                                <div>
                                  <div className="text-center mb-4">
                                    <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-2">
                                      DISTANCIA RECORRIDA
                                    </div>
                                    <div className="text-white text-2xl font-semibold font-montserrat">
                                      {((prevision.distancia + prevision.inicioDistancia) / 1000).toFixed(1)} km
                                    </div>
                                  </div>
                                  <div className="text-center mb-4">
                                    <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-2">
                                      PREVISIÓN EN {prevision.control.nombre}
                                    </div>
                                    <div className="text-red-400 text-2xl font-mono font-bold">
                                      {formatMs(prevision.tiempoTotal)}
                                    </div>
                                  </div>
                                  <div className="text-center mb-4">
                                    <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-2">
                                      HORA DE LLEGADA PREVISTA
                                    </div>
                                    <div className="text-white text-2xl font-mono font-bold">
                                      {formatMs(((competicion.tipo === 'TIEMPONETO' && resultado.start) ? resultado.start : (resultado.guntime || guntime)) + prevision.tiempoTotal)} h
                                    </div>
                                  </div>
                                  <div className="mt-4">
                                    <div className="h-2 w-full bg-slate-800 rounded-full overflow-hidden">
                                      <div
                                        className="h-full bg-red-500 transition-all duration-300"
                                        style={{ width: `${prevision.porcentaje}%` }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className="bg-slate-900/50 border border-slate-700 rounded-lg px-6 py-8 text-center">
                              <div className="text-slate-400 text-sm uppercase tracking-wide font-montserrat mb-3">
                                ESTADO
                              </div>
                              <div className="text-slate-500 text-2xl font-montserrat">
                                NO PRESENTADO
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResultadoDetailTiempo;